module.exports = __webpack_public_path__ + "img/tablo_7519de8.svg";